import { blockCategories } from '../../categories';

const COMPONENT_TYPE = 'teaser-wishlist-button';
const BLOCK_ID = 'teaser-wishlist-button';

const HEART_ICON_SVG = `<svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M9.74899 18.4991C9.64299 18.4991 9.53696 18.4771 9.43796 18.4321C9.11096 18.2831 1.415 14.7141 0.180999 8.35808C-0.296001 5.89908 0.183005 3.50007 1.46201 1.94207C2.497 0.680069 3.98496 0.00905195 5.76596 5.1954e-05C5.77496 5.1954e-05 5.78396 5.1954e-05 5.79196 5.1954e-05C7.82396 5.1954e-05 9.06301 1.15708 9.74802 2.14208C10.436 1.15308 11.6849 -0.00894805 13.7299 5.1954e-05C15.5119 0.00905195 17.001 0.680069 18.037 1.94207C19.314 3.49907 19.7919 5.89806 19.3139 8.35906C18.0819 14.7151 10.385 18.2851 10.058 18.4331C9.96095 18.4771 9.85499 18.4991 9.74899 18.4991ZM5.79098 1.49908C5.78498 1.49908 5.78002 1.49908 5.77402 1.49908C4.43602 1.50508 3.37604 1.97406 2.62204 2.89306C1.62304 4.11006 1.26202 6.04607 1.65402 8.07207C2.60902 12.9961 8.34199 16.1961 9.74899 16.9141C11.156 16.1961 16.889 12.9961 17.843 8.07207C18.237 6.04507 17.876 4.10906 16.879 2.89306C16.125 1.97506 15.065 1.50705 13.724 1.50005C13.718 1.50005 13.712 1.50005 13.707 1.50005C11.335 1.50005 10.4941 3.87708 10.4601 3.97808C10.3561 4.28108 10.07 4.48705 9.74997 4.48705C9.74797 4.48705 9.74694 4.48705 9.74594 4.48705C9.42494 4.48605 9.13896 4.28106 9.03696 3.97607C9.00396 3.87607 8.16198 1.49908 5.79098 1.49908Z" fill="currentColor"/>
</svg>`;


export default function wishlistButton(editor) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    domComponents.addType(COMPONENT_TYPE, {
        model: {
            defaults: {
                tagName: 'div',
                name: 'Wishlist Button',
                droppable: false,
                draggable: true,
                stylable: true,
                highlightable: true,
                editable: false,
                attributes: {
                    class: 'sio-teaser-wishlist-button',
                    'data-siotype': COMPONENT_TYPE,
                },
                components: HEART_ICON_SVG,
                traits: [],
            },
        },
        view: {},
    });

    blockManager.add(BLOCK_ID, {
        label: 'Wishlist',
        category: blockCategories.teaser,
        media: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor" d="M12.1 18.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"/>
        </svg>`,
        content: {
            type: COMPONENT_TYPE,
            attributes: {
                class: 'sio-teaser-wishlist-button',
                'data-siotype': COMPONENT_TYPE,
            },
            components: HEART_ICON_SVG,
        },
    });
}
